import React, { useState, useRef } from "react";
import Terminal from "./terminal";
import Modal from "./Modal";

const ApplicationForm = ({ role, buttonClassName = "w-full" }) => {

  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => setIsOpen(true);

  const buttonRef = useRef(null);

  const [formData, setFormData] = useState({
    role: role,
    name: "",
    email: "",
    phone: "",
    linkedin: "",
    cvLink: "",
    message: "",
  });

  const [message, setMessage] = useState("");

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const validateUrl = (value) => /^https?:\/\/\S+\.\S+/.test(value.trim());
  const hasValue = (value) => value.trim() !== "";

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [errors, setErrors] = useState({});

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { role, name, email, phone, linkedin, cvLink, message } = formData;

    const newErrors = {};
    if (!hasValue(role)) newErrors.role = true;
    if (!hasValue(name)) newErrors.name = true;
    if (!validateEmail(email)) newErrors.email = true;
    if (!hasValue(phone)) newErrors.phone = true;
    if (!hasValue(linkedin)) newErrors.linkedin = true;
    if (hasValue(cvLink) && !validateUrl(cvLink)) newErrors.cvLink = true;
    if (!hasValue(message)) newErrors.message = true;

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setSubmitSuccess(false);
      setMessage("Ditt ansökan har inte skickats.\n\nSäkerställ att de obligatoriska fälten är ifyllda korrekt.");
      return;
    }

    const data = {
      name: formData.name,
      role: formData.role,
      email: formData.email,
      phone: formData.phone,
      linkedin: formData.linkedin,
      cvLink: formData.cvLink,
      message: formData.message
    };


    try {
      await fetch("https://api.dev.acebit.se/job_application/", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });

      setSubmitSuccess(true);
      setMessage("Din ansökan har skickats!");
      setErrors({});
    } catch (error) {
      setSubmitSuccess(false);
      setMessage("Ett fel inträffade när meddelandet skickades.\n\nFörsök igen senare.");
    }
  };

  return (
    <>
      <button
        className={`btn-primary ${buttonClassName}`}
        onClick={openModal}
        ref={buttonRef}
      >
        Ansök
      </button>
      {isOpen && (
        <Modal onClose={() => setIsOpen(false)}>
          <Terminal title="application" onClose={() => setIsOpen(false)}>

              {submitSuccess ? <div className="flex">{message}</div> :
                <form id="application-form" className="flex flex-col gap-2" onSubmit={handleSubmit}>
                  <input
                    type="text"
                    value={formData.role}
                    readOnly
                    className="input opacity-70"
                  />
                  <input
                    type="text"
                    name="name"
                    placeholder="Name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    maxLength={100}
                    className={`input ${errors.name ? "border-2 border-red-500" : ""}`}
                  />
                  <input
                    type="email"
                    name="email"
                    placeholder="Email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    maxLength={200}
                    className={`input ${errors.email ? "border-2 border-red-500" : ""}`}
                  />
                  <input
                    type="text"
                    name="phone"
                    placeholder="Telefon"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    maxLength={30}
                    className={`input ${errors.phone ? "border-2 border-red-500" : ""}`}
                  />
                  <input
                    type="text"
                    name="linkedin"
                    placeholder="LinkedIn"
                    value={formData.linkedin}
                    onChange={handleChange}
                    required
                    maxLength={200}
                    className={`input ${errors.linkedin ? "border-2 border-red-500" : ""}`}
                  />
                  <input
                    type="url"
                    name="cvLink"
                    placeholder="Länk till CV (Google Drive, LinkedIn, etc.)"
                    value={formData.cvLink}
                    onChange={handleChange}
                    maxLength={500}
                    className={`input ${errors.cvLink ? "border-2 border-red-500" : ""}`}
                  />
                  <textarea
                    name="message"
                    placeholder="Meddelande"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    maxLength={2000}
                    className={`input min-h-28 resize-none ${errors.message ? "border-2 border-red-500" : ""}`}
                  />
                  <div className="w-full">
                    <button type="submit" className="btn-primary mt-2 w-full">
                      Skicka
                    </button>
                  </div>
                </form>
              }
          </Terminal>
        </Modal>
      )}
    </>
  );
};


export default ApplicationForm;